import React, { Fragment, useEffect, useState, forwardRef } from "react";
import AsyncSelect from "react-select/async";

const DropDownFetchCount = forwardRef(({
  onSelected,
  defaultSelection,
  placeholderText = "Number of Rows",
  disabled = false,
}, ref) => {
  const fetchCounts = [10, 25, 50, 100];
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (defaultSelection === null || defaultSelection === undefined) return;
    
    // Find the option that matches the default selection
    const option = { value: defaultSelection, label: `${defaultSelection} rows` };
    setSelected(option);
  }, [defaultSelection]);

  const getFetchCounts = async () => {
    try {
      // Convert the fetch counts to the format expected by react-select
      const options = fetchCounts.map(count => ({
        value: count,
        label: `${count} rows`
      }));
      
      return options;
    } catch (error) {
      console.log("Error fetching row counts");
      console.log(error);
    }
    return [];
  };

  const selectFetchCount = (option) => {
    setSelected(option);
    onSelected(option?.value);
  };

  const promiseOptions = () =>
    new Promise((resolve) => {
      setTimeout(() => {
        resolve(getFetchCounts());
      }, 100);
    });

  // Expose methods to the parent component via ref
  React.useImperativeHandle(ref, () => ({
    reset: () => {
      // When resetting, we want to default to 25 rows instead of null
      const defaultOption = { value: 25, label: "25 rows" };
      setSelected(defaultOption);
      onSelected(25);
    }
  }));

  return (
    <Fragment>
      <AsyncSelect
        className={"fs-input"}
        cacheOptions
        loadOptions={promiseOptions}
        defaultOptions={true}
        onChange={(data) => {
          selectFetchCount(data);
        }}
        value={selected}
        placeholder={placeholderText}
        isDisabled={disabled}
      />
    </Fragment>
  );
});

export default DropDownFetchCount;
